import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../../../components/ui/Card';
import { CalendarDays, AlertCircle, ArrowRightCircle, Gavel } from 'lucide-react';
import { formatDate } from '../../../utils/formatters';

export default function TransactionSidebar({ transaction }) {
  if (!transaction) return null;

  return (
    <div className="space-y-6">
      {/* Échéances */}
      <Card className="shadow-hp-sm">
        <CardHeader className="p-5 border-b border-[var(--hp-color-border-muted)] flex flex-row items-center gap-2">
          <CalendarDays className="w-4 h-4 text-primary" />
          <CardTitle className="text-sm font-semibold">Calendrier</CardTitle>
        </CardHeader>
        <CardContent className="p-5">
          <ul className="space-y-4">
            <li className="flex justify-between text-sm">
              <span className="text-subtle">Lancement</span>
              <span className="font-medium text-primary">{formatDate(transaction.startDate)}</span>
            </li>
            <li className="flex justify-between text-sm">
              <span className="text-subtle">Clôture prévue</span>
              <span className="font-medium text-primary">{formatDate(transaction.expectedCloseAt)}</span>
            </li>
            <li className="flex justify-between text-sm">
              <span className="text-subtle">Sortie prévue</span>
              <span className="font-medium text-primary">{formatDate(transaction.expectedExitAt)}</span>
            </li>
          </ul>
        </CardContent>
      </Card>

      {/* Décision du Comité si origine dossier */}
      {transaction.originDossier && (
        <Card className="shadow-hp-sm border-[var(--hp-info-200)] dark:border-[var(--hp-info-800)]">
          <CardHeader className="p-5 border-b border-[var(--hp-info-100)] dark:border-[var(--hp-info-900)] flex flex-row items-center gap-2 bg-[var(--hp-info-50)] dark:bg-[var(--hp-info-950)] rounded-t-xl">
            <Gavel className="w-4 h-4 text-[var(--hp-info-600)]" />
            <CardTitle className="text-sm font-semibold text-[var(--hp-info-900)] dark:text-[var(--hp-info-200)]">Décision du Comité</CardTitle>
          </CardHeader>
          <CardContent className="p-5 text-sm space-y-2">
            <div>
              <span className="text-xs text-subtle uppercase font-semibold">Dossier Source :</span>
              <p className="font-medium text-primary">#{transaction.originDossier.reference} - {transaction.originDossier.title}</p>
            </div>
            {transaction.originDossier.decisionComment && (
              <div>
                <span className="text-xs text-subtle uppercase font-semibold">Avis / Commentaire :</span>
                <p className="text-xs text-primary italic bg-surface p-2.5 rounded-lg border border-[var(--hp-color-border-muted)] mt-1">
                  "{transaction.originDossier.decisionComment}"
                </p>
              </div>
            )}
            {transaction.originDossier.decisionConditions && (
              <div>
                <span className="text-xs text-subtle uppercase font-semibold">Conditions Suspensives :</span>
                <p className="text-xs text-primary bg-surface p-2.5 rounded-lg border border-[var(--hp-color-border-muted)] mt-1">
                  {transaction.originDossier.decisionConditions}
                </p>
              </div>
            )}
          </CardContent>
        </Card>
      )}

      {/* Prochaine Action */}
      <Card className="shadow-hp-sm">
        <CardHeader className="p-5 border-b border-[var(--hp-color-border-muted)] flex flex-row items-center gap-2">
          <ArrowRightCircle className="w-4 h-4 text-primary" />
          <CardTitle className="text-sm font-semibold">Prochaine action</CardTitle>
        </CardHeader>
        <CardContent className="p-5">
          <p className="text-sm text-subtle text-center italic py-2">
            Aucune action urgente identifiée.
          </p>
        </CardContent>
      </Card>

    </div>
  );
}
